import { IApplicationContext } from '../../../types/applicationContext';
import { GenericError } from '@cian/peperrors';
import {
  fetchInsuranceAccept,
  type TInsuranceAcceptResponse,
} from '../../../repositories/dailyrent/v2/insurance/accept';

export const fetchConfirmInsuranceActivation = async (context: IApplicationContext) => {
  const { httpApi, logger } = context;

  try {
    const { statusCode } = (await fetchInsuranceAccept({
      httpApi,
    })) as TInsuranceAcceptResponse;

    if (statusCode !== 200) {
      throw new Error();
    }
  } catch (err) {
    const error = new GenericError({
      type: 'fetchFailed',
      domain: 'fetchConfirmInsuranceActivation',
      message: `Ошибка при активации страхования`,
    });

    logger.error(error);

    throw error;
  }
};
